module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/send-6e19a8edab0c7888c8b3b50c97757e67.svg";